import React, { useState } from "react";
import { Table, Row, Col, Button, Space, message } from "antd";
import LiquidatedDamageModal from "./LiquidatedDamagesModal";
import { removeLiquidatedDamages } from "../../../../../services/vendorProfile.services";
import { confirmModal } from "../../../../../reusable/ModalWizz";
import { LiquidatedDamagesColumns } from "../../../../PQQ/tableColumns";

const LiquidatedDamage = (props) => {
  const [visible, setVisible] = useState(false);
  const [editTable, setEditTable] = useState(null);

  const refreshPage = () => {
    props.fetchLiquidatedDamages();
  };

  const openModal = (data) => {
    setVisible(true);
    setEditTable(data);
  };

  const removeColumn = (id) => {
    removeLiquidatedDamages({
      id: id,
      vendor_id: props.vendorId,
    })
      .then((response) => {
        refreshPage();
        message.success(response.data.message);
      })
      .catch((error) => {
        message.error(error.response.data.message);
      });
  };

  const columns = [
    ...LiquidatedDamagesColumns,
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            className="footer-links"
            onClick={() => openModal({ ...record, status: "update" })}
          >
            Edit
          </span>
          <span
            className="footer-links"
            onClick={() => {
              confirmModal({
                title: `Are you sure to delete this record?`,
                onOk: () => removeColumn(record.id),
              });
            }}
          >
            Delete
          </span>
        </Space>
      ),
    },
  ];

  return (
    <Row>
      <Col span={22} offset={1}>
        <Button
          onClick={openModal}
          type="secondary"
          style={{
            marginBottom: 16,
          }}
        >
          Add Contract
        </Button>
        <Table
          size="small"
          columns={columns}
          dataSource={props.liquidatedDamagesData}
          pagination={false}
          scroll={{ x: 800 }}
        />
      </Col>

      {visible && (
        <LiquidatedDamageModal
          setVisible={setVisible}
          title="Add Contract"
          vendorId={props.vendorId}
          editTable={editTable}
          refresh={refreshPage}
        />
      )}
    </Row>
  );
};

export default LiquidatedDamage;
